import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const sessionStorage =
  typeof window !== `undefined` ? window.sessionStorage : undefined;

const { persistAtom } = recoilPersist({
  key: "eventPersist",
  storage: sessionStorage,
});

export const consult22EventAtom = atom<any>({
  key: "consult22EventAtom",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
